import { Injectable } from '@angular/core';
import {
  AttachmentAttachmentRead,
  IssueReportAppEntityIssueReportRead,
  IssueReportAttachmentService,
  IssueReportService
} from '../openapi';
import { forkJoin, mapTo, Observable, of, switchMap } from 'rxjs';

@Injectable()
export class IssueReportCommonService {
  constructor(
    private issueReportService: IssueReportService,
    private issueReportAttachmentService: IssueReportAttachmentService
  ) {
  }

  public sendReport(payload: any, attachments: AttachmentAttachmentRead[]): Observable<IssueReportAppEntityIssueReportRead> {
    return this.issueReportService.postIssueReportIssueReportCollection({
      issueReport: payload
    }).pipe(
      switchMap((report) => (
          attachments.length ? forkJoin(
            attachments?.map(attachment => this.issueReportAttachmentService.postIssueReportAttachmentCollectionIssueReportAttachmentCollection({
              issueReportAttachment: {
                issueReport: report?.id,
                attachment: attachment?.id
              }
            }))
          ) : of([])
        ).pipe(mapTo(report))
      )
    );
  }
}
